import { render, staticRenderFns } from "./EventListReg.vue?vue&type=template&id=5d8df6f6&"
import script from "./EventListReg.vue?vue&type=script&lang=js&"
export * from "./EventListReg.vue?vue&type=script&lang=js&"
import style0 from "./EventListReg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports